import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API } from "../config/api-config";
import { FileUpload } from "../service/file-upload";
import { HttpService } from "../service/http-service";
import { StroageService } from "../service/stroage";

declare var alertify: any;

@Component({
  selector: "app-app-account",
  templateUrl: "./app-account.component.html",
  styleUrls: ["./app-account.component.css"],
})
export class AppAccountComponent implements OnInit {
  constructor(
    private router: Router,
    private HttpService: HttpService,
    private fileUpload: FileUpload,
    private stroage: StroageService
  ) {}

  ngOnInit() {
    this.getData();
  }

  public data: Array<any> = [];
  public searchValue: Object = {
    account: "",
    memberType: "",
  };
  public page: Object = { pageNumber: 1 };
  private getData(isSearch = false): void {
    let data = { ...this.page };
    data["pageNumber"]--;

    if (isSearch) {
      data = { ...data, ...this.searchValue };
    }
    this.HttpService.getData(API.deletedAccountList, data).then((res) => {
      this.data = res.data.content;
      this.pageData = res.data;
    });
  }

  public pageData: object = {};

  public pageChange(e: any) {
    this.page = e;
    this.getData(true);
  }

  public getTypeName(name: string): String {
    switch (name) {
      case "Member":
        return name;
      case "ExperienceMember":
        return "Experience Member";
    }
  }

  public searchData() {
    this.getData(true);
  }

  public recovery(account: String): void {
    const _self = this;
    alertify.confirm(
      "Recovery",
      "確定要恢復賬號嗎？",
      function () {
        _self.HttpService.postData(API.recoveryAccount + account, {}).then(
          (res) => {
            if (res.status.code == 0) {
              alertify.success(res.status.message);
              _self.getData(true);
            } else {
              alertify.error(res.status.message);
            }
          }
        );
      },
      function () {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/app-account/app-account.component.ts